export default {
  codename: "",
  image: "",
  description: "",
  categoryIds: null,
};
